import * as React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

import { DocsLayout } from '@/components/docs/DocsLayout'
import { GettingStarted } from '@/pages/docs/GettingStarted'
import { DocCreateAd } from '@/pages/docs/DocCreateAd'
import { DocCreateImage } from '@/pages/docs/DocCreateImage'
import { DocProducts } from '@/pages/docs/DocProducts'
import { DocAssetLibrary } from '@/pages/docs/DocAssetLibrary'
import { DocJobs } from '@/pages/docs/DocJobs'

export function Docs() {
  return (
    <Routes>
      <Route element={<DocsLayout />}>
        <Route index element={<GettingStarted />} />
        <Route path="create-ad" element={<DocCreateAd />} />
        <Route path="create-image" element={<DocCreateImage />} />
        <Route path="products" element={<DocProducts />} />
        <Route path="assets" element={<DocAssetLibrary />} />
        <Route path="jobs" element={<DocJobs />} />
        <Route path="*" element={<Navigate to="/docs" replace />} />
      </Route>
    </Routes>
  )
}
